// axios
import axios from 'axios';
import * as Config from "resources/js/router/config";

export default {
 setEmailSearchQuery({commit}, query) {
  commit('SET_EMAIL_SEARCH_QUERY', query)
 },
 
 // Fetch emails
 fetchEmails({commit}, payload) {
  return new Promise((resolve, reject) => {
   commit('SET_MAIL_LOADING', true);
   axios.get(Config.apiPath + 'msgraph/emails/folders/' + payload.filter + '/messages?skip=' + payload.maiSkip).then(
    response => {
     commit('SET_MAIL_LOADING', false);
     if (response.data.is_redirect) {
      window.location.href = response.data.redirect_url;
     }
     else {
      commit('SET_MAILS', response.data.messages.data.value, payload.filter);
      commit('SET_MAIL_SKIP', parseInt(response.data.messages.skip));
      commit('SET_MAIL_TOP', parseInt(response.data.messages.top));
      if (response.data.messages.data.value.length < response.data.messages.top) {
       commit('SET_MAIL_END', true);
      }
      // resolve();
      resolve(response);
     }
    })
    .catch((error) => {
     commit('SET_MAIL_LOADING', false);
     reject(error);
    });
  });
 },
 
 fetchMailFolders({commit}) {
  return new Promise((resolve, reject) => {
   axios.get(Config.apiPath + 'msgraph/emails/folders').then(
    response => {
     if (response.data.is_redirect) {
      window.location.href = response.data.redirect_url;
     }
     else {
      commit('SET_FOLDERS', response.data.folders);
      resolve(response);
     }
    })
    .catch((error) => {
     reject(error);
    });
  })
 },
 
 // Move mails to another folder
 moveMailsTo({commit}, payload) {
  return new Promise((resolve, reject) => {
   axios.post(Config.apiPath + 'msgraph/emails/' + payload.emailIds[0] + '/move', {
    destinationId: payload.to
   }).then(
    response => {
     if (response.data.is_redirect) {
      window.location.href = response.data.redirect_url;
     }
     else {
      commit('MOVE_MAILS_TO', payload);
      commit('UPDATE_UNREAD_META_ON_MOVE', payload);
      resolve(response);
     }
    })
    .catch((error) => {
     reject(error);
    });
  })
 },
 
 // Set mails flag unread to true
 setUnread({commit}, payload) {
  return new Promise((resolve, reject) => {
   commit('SET_MAIL_UPDATING', true);
   axios.patch(Config.apiPath + 'msgraph/emails/' + payload.emailIds[0] + '/update', {
    isRead: !payload.unreadFlag
   }).then(
    response => {
     commit('SET_MAIL_UPDATING', false);
     if (response.data.is_redirect) {
      window.location.href = response.data.redirect_url;
     }
     else {
      commit('SET_UNREAD', payload);
      commit('UPDATE_UNREAD_META', payload);
      resolve(response);
     }
    })
    .catch((error) => {
     commit('SET_MAIL_UPDATING', false);
     reject(error);
    });
  })
 },
}
